import { QueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import type { UseTranslationResponse } from "react-i18next";

import { NotificationToast } from "../../components/Generic/Toast/NotificationToast";
import type { Error } from "../../models/error";
import { checkError } from "../checkError";
import { TypeError } from "../enums";

export const createQueryClient = (translate: UseTranslationResponse<"translation">["t"]) => {
  const onError = (error: unknown) => {
    const errorAxios = error as AxiosError<Error>;

    if (errorAxios?.response?.data && typeof errorAxios?.response?.data === "object") {
      checkError(errorAxios, translate("anErrorOccurredTryAgain"));
    } else {
      const isErroWithoutToast = errorAxios?.response?.data?.type === TypeError.ERROR_WITHOUT_TOAST;
      const message = errorAxios?.response?.data?.message;

      if (!isErroWithoutToast) {
        NotificationToast.error(
          message && typeof message === "string" ? message : translate("anErrorOccurredTryAgain"),
          { id: "react.query.default.error" }
        );
      }
    }
  };

  const queryClient = new QueryClient({
    defaultOptions: {
      mutations: {
        onError,
      },
      queries: {
        onError,
        refetchOnWindowFocus: false,
      },
    },
  });

  return queryClient;
};
